import { render, staticRenderFns } from "./cart-list.vue?vue&type=template&id=4ba2396d&scoped=true&"
import script from "./js/cart-list.js?vue&type=script&lang=js&"
export * from "./js/cart-list.js?vue&type=script&lang=js&"
import style0 from "./cart-list.vue?vue&type=style&index=0&id=4ba2396d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ba2396d",
  null
  
)

export default component.exports